// extracted by mini-css-extract-plugin
export default {"label":"styles_label__Apmzx","error":"styles_error__TEX2w","checkbox":"styles_checkbox__m43jq"};